<button mat-flat-button color="{{buttonColor}}" *ngIf="!buttonLinkActive" type="button" [class]="buttonClass">
  {{ buttonText }}
</button>

<button
  mat-flat-button
  color="{{buttonColor}}"
  *ngIf="buttonLinkActive"
  type="button"
  [class]="buttonClass"
  [routerLink]="buttonLink"
  [disabled]="buttonDisabled"
>
  {{ buttonText }}
</button>
